import { api } from './api';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  createdAt: string;
  updatedAt: string;
  fullName: string;
}

export interface UpdateProfileDto {
  firstName?: string;
  lastName?: string;
  email?: string;
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ChangePasswordResponse {
  message: string;
}

class ProfileService {
  /**
   * Get current user profile
   */
  async getProfile(): Promise<User> {
    const response = await api.get<User>('/profile');
    return response.data;
  }

  /**
   * Update user profile
   */
  async updateProfile(data: UpdateProfileDto): Promise<User> {
    const response = await api.put<User>('/profile', data);
    return response.data;
  }

  /**
   * Change user password
   */
  async changePassword(
    data: ChangePasswordDto
  ): Promise<ChangePasswordResponse> {
    const response = await api.put<ChangePasswordResponse>(
      '/profile/password',
      data
    );
    return response.data;
  }
}

export const profileService = new ProfileService();
export default profileService;
